import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {animate, animateChild, group, keyframes, query, state, style, transition, trigger} from "@angular/animations";
import {TileFolderDisplayMode} from "../../../../shared/models/tile";
import {FormsModule} from '@angular/forms';


@Component({
  selector: 'motn-folder-view-flip-toggle',
  templateUrl: './folder-view-flip-toggle.component.html',
  styleUrls: ['./folder-view-flip-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
  ],
})
export class FolderViewFlipToggleComponent {
    @Input() displayMode = TileFolderDisplayMode.Default;
    @Output() displayModeChange: EventEmitter<TileFolderDisplayMode> = new EventEmitter<TileFolderDisplayMode>();

    get displayModeText(): string {
        switch (this.displayMode) {
            case TileFolderDisplayMode.Default:
                return 'Default'
            case TileFolderDisplayMode.DataPoints:
                return 'Data points'
        }
    }

    onDisplayModeChange(newDisplayMode: TileFolderDisplayMode) {
        this.displayModeChange.emit(newDisplayMode);
    }
}
